module.exports = __webpack_public_path__ + "img/home-banner-man.ca9b6acf.png";